module.exports = __webpack_public_path__ + "img/wxPng.e0b91f5b.png";